import React from 'react';
import { CATEGORIES } from '../api/strapiClient';

export default function CategoryFilter({ selected, onSelect }) {
  const options = ['All', ...CATEGORIES];

  return (
    <nav className="category-filter" aria-label="Filter articles by category">
      {options.map((cat) => (
        <button
          key={cat}
          type="button"
          className={
            'category-filter__item' +
            (selected === cat ? ' category-filter__item--active' : '')
          }
          onClick={() => onSelect(cat)}
        >
          {cat}
        </button>
      ))}
    </nav>
  );
}
